<template>
  <div class="row">
    <div class="col-md-12">
      <div v-if="site" class="row pb-2">
        <div class="col-md-12">
          <Cdn :plan="plan" :site="site" :site-status="siteStatus" namespace="devSites" />
        </div>
      </div>
      <div class="row pb-4">
        <div class="col-md-12">
          <Bandwidth
            :plan="plan"
            :plan-status="planStatus"
            :site="site"
            :site-status="siteStatus"
          />
        </div>
      </div>
      <div class="row pb-4">
        <div class="col-md-12">
          <PhpFpm :plan="plan" :plan-status="planStatus" :site="site" :site-status="siteStatus" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Bandwidth from "@/components/smart/cards/Bandwidth";
import Cdn from "@/components/smart/cards/Cdn";
import PhpFpm from "@/components/smart/cards/PhpFpm";
import store from "@/store";

export default {
  name: "DevSitePerformancePage",
  components: {
    Bandwidth,
    Cdn,
    PhpFpm,
  },
  setup() {
    const plan = computed(() => store.getters["plans/getItem"]);
    const planStatus = computed(() => store.getters["plans/getItemStatus"]);
    const site = computed(() => store.getters["devSites/getItem"]);
    const siteStatus = computed(() => store.getters["devSites/getItemStatus"]);

    onMounted(() => {
      const siteId = site.value.id;
      store.dispatch("devSites/get", siteId);
    });

    return {
      plan,
      planStatus,
      site,
      siteStatus,
    };
  },
};
</script>
